import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import * as firebase from "firebase"

Vue.config.productionTip = false

const firebaseConfig  = {
  apiKey: "AIzaSyAcfEhKoAjVZ3207kvA8Oyx72rN-gbRfUg",
  authDomain: "iosper-prescripcion.firebaseapp.com",
  databaseURL: "https://iosper-prescripcion.firebaseio.com",
  projectId: "iosper-prescripcion",
  storageBucket: "iosper-prescripcion.appspot.com",
  messagingSenderId: "449798592824",
  appId: "1:449798592824:web:9374e8fcb44cf2c8c4c9cd",
  measurementId: "G-05YZ4VZ705"
};

firebase.initializeApp(firebaseConfig);

const messaging = firebase.messaging()

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
});

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
      const unsubscribe = firebase.auth().onAuthStateChanged(user => {
          unsubscribe();
          resolve(user);
      }, reject);
  })
};

new Vue({
  router,
  store,
  messaging,
  vuetify,
  render: h => h(App)
}).$mount('#app')
